import { FormGroup, Label } from 'reactstrap';
import styled from 'styled-components';
import { DropdownButtonField, ValidatedInput } from './template-components';
import { ASSIGNMENTS } from '../../constants/capexes';

// color and border color are coming from bootstrap's grey-700 and grey-400
// TODO: update to reference directly once able to use SASS vars directly
export const StyledDropdownButtonField = styled(DropdownButtonField)`
  background-color: #fff;
  color: #495057;
  border: 1px solid #ced4da;
  height: 31px;
`;

export const UnitCostInput = ({ children, ...props }) => (
  <ValidatedInput
    type="number"
    name="unitCost"
    label="Unit Cost"
    labelClassName="text-nowrap"
    min={0}
    step={0.01}
    {...props}
  >
    {children}
  </ValidatedInput>
);

export const QuantityInput = ({ children, ...props }) => (
  <ValidatedInput
    min={1}
    type="number"
    name="quantity"
    label="Quantity"
    step={1}
    {...props}
  >
    {children}
  </ValidatedInput>
);

export const PurchaseYearInput = ({ children, ...props }) => (
  <ValidatedInput
    type="number"
    name="purchaseYear"
    label="Purchase Year"
    labelClassName="text-nowrap"
    min={1}
    max={30}
    step={1}
    {...props}
  >
    {children}
  </ValidatedInput>
);

export const AssignmentInput = ({ isSuperadmin, ...props }) => (
  <FormGroup>
    <Label>Assignment</Label>
    <StyledDropdownButtonField
      inModal
      size="sm"
      options={ASSIGNMENTS}
      name="assignment"
      disabled={!isSuperadmin}
      {...props}
    />
  </FormGroup>
);
